module.exports = __webpack_public_path__ + "img/flags2x.87824637.png";